import React, { useEffect, useState, useRef } from "react";
import { connectE2Value } from "requests/qualityAssurance";
import { MSpinner } from "components/Shared";
import { Button } from "react-md";
import { E2ValueConnectResponse } from "interfaces/Mueller.Business.Models";

interface Props {
  controlIdNumber: number,
}

const E2Value = ({
  controlIdNumber,
} : Props) => {

  const mounted = useRef<boolean>(true);
  const [fetching, setFetching] = useState<boolean>(false);
  const [e2ValueProps, setE2ValueProps] = useState<E2ValueConnectResponse>(null);

  useEffect(() => {
    return () => { mounted.current = false };
  }, []);

  if (fetching) return (<MSpinner />)

  const onClick = () => {
    setFetching(true);
    connectE2Value(controlIdNumber, (data: E2ValueConnectResponse) => {
      setE2ValueProps(data);
      setFetching(false);
    }, mounted);
  };

  if (e2ValueProps === null) {
    return (
      <Button 
        raised 
        primary 
        onClick={onClick}
        >Connect e2Value</Button>
    );
  }

  return (<div>
    <iframe src={e2ValueProps.url}
      style={{
        width: "100%",
        height: "800px",
      }} />
  </div>);
};

export default E2Value;